import React, { useState } from 'react'

import { PlusOutlined, UploadOutlined, QuestionCircleFilled } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import InboundListView from '@components/shared/inbounds/InboundListView'
import OperatorInboundConceptModal from '@shared/inbounds/OperatorInboundConceptModal'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import ListPageHeader from '@shared/ListPageHeader'
import Can from '@shared/permissions/Can'

import { inboundService } from '@services/operator/inboundService'
import { useOperatorSupplierService } from '@hooks/operator/suppliers/useOperatorSupplierService'

const OperatorInboundList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { addJob } = useOperatorNotification()
  const isStandard = useIsStandard()
  const [importModalVisible, setImportModalVisible] = useState(false)
  const [conceptModalVisible, setConceptModalVisible] = useState(false)
  // List 為跨 merchant view；不主動指定 merchantId，由 hook 從 OperatorDataContext 取目前選定的 merchant。
  // 若 context 未設定（cross-merchant 模式），merchant_id 會是 undefined，BE 視為不過濾。
  const supplierService = useOperatorSupplierService()

  return (
    <div>
      <ListPageHeader
        items={['inbounds', 'inbounds.list']}
        guideButton={
          <Tooltip title={t('concepts.inbounds_operator.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
        actions={
          <>
            <Can requiredPermission="inbounds:write">
              <Button icon={<UploadOutlined />} onClick={() => setImportModalVisible(true)}>
                {t('common.button.import')}
              </Button>
            </Can>
            <Can requiredPermission="inbounds:write">
              <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/inbounds/new')}>
                {t('common.button.new')}
              </Button>
            </Can>
          </>
        }
      />
      <InboundListView
        service={inboundService}
        supplierService={supplierService}
        role="operator"
        showMerchantColumn={!isStandard}
        addJob={addJob}
        importModalVisible={importModalVisible}
        setImportModalVisible={setImportModalVisible}
      />
      <OperatorInboundConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}

export default OperatorInboundList
